import { css, Theme } from "@emotion/react";
import {
  fullGrid,
  gridColumn,
  section,
  topMargin,
} from "@hl/communities-app/lib/styles/global/layout";

export const loading = css`
  text-align: center;
  padding-top: 100px;
`;

export const layout = css`
  ${section};
  ${fullGrid};
  ${topMargin("13/64px")};
`;

export const layout2 = css`
  ${topMargin("10/40px")};
`;

export const editorCol = css`
  ${gridColumn([2, 13])};
`;

export const mainContainer = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  ${topMargin("9/32px")};
`;

export const container = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const rowContainer = css`
  display: flex;
  flex-direction: column;
`;

export const noCollectionsCreatedContainer = css`
  text-align: center;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  ${topMargin("6/16px")}
`;

export const pageToolsContainer = (theme: Theme) => css`
  align-self: right;
  justify-content: right;
  display: flex;
  align-items: right;
  padding: 0;
  ${theme.mediaQueries.smallOnly} {
    align-self: left;
    justify-content: left;
    align-items: left;
    ${topMargin("6/16px")}
  }
`;

export const createGatedPageButton = css`
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  width: 100%;
  background: linear-gradient(91.02deg, #8900ca 0%, #d272ff 100%);
  border-radius: 6px;
  height: 45px;
`;

export const createNoPageButton = css`
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  background: linear-gradient(91.02deg, #8900ca 0%, #d272ff 100%);
  border-radius: 6px;
  height: 45px;
  width: auto;
  margin-left: auto;
  margin-right: auto;
`;

export const pageContainer = (theme: Theme) => css`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  ${topMargin("6/16px")}
  ${theme.mediaQueries.smallOnly} {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
  }
`;

export const pageDescription = css`
  align-self: left;
  justify-content: left;
  display: flex;
  flex-direction: column;
  margin-right: auto;
  align-items: left;
  padding: 0;
  margin: 0;
`;
